export const SET_USER = 'SET_USER';
export const SET_VISITS = 'SET_VISITS';
export const SET_MAILS = 'SET_MAILS';
export const SET_HAS_SUBS = 'SET_HAS_SUBS';
export const SET_STATE = 'SET_STATE';
export const SET_UPDATED_EMAIL = 'SET_UPDATED_EMAIL';
export const SET_VERSION = 'SET_VERSION';
export const SET_REQUIRE_UPDATE = 'SET_REQUIRE_UPDATE';



// WEBPACK FOOTER //
// ./src/store/commitTypes.js